
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';

export default ComponentInitializeDispatcher.extend({
  name: 'owc-subnavigation-arrow',
  props: {
    hasBackground: {
      required: false,
      type: Boolean,
      default: true,
    },
    buttonLabel: {
      required: false,
      type: String,
    },
    buttonOptionalClasses: {
      required: false,
      type: Array,
      default: function() {
        return [];
      },
    },
    iconName: {
      required: true,
      type: String,
    },
    iconOptionalClasses: {
      required: false,
      type: Array,
      default: function() {
        return [];
      },
    },
    backgroundOptionalClasses: {
      required: false,
      type: Array,
      default: function() {
        return [];
      },
    },
    direction: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      prefixClass: 'owc-subnavigation',
    };
  },
  computed: {
    shouldShowBackground: function(): boolean {
      return this.direction !== '';
    },
  },
  methods: {
    getClassedBasedOnDirection: function(classToAppend: string): string {
      const resultClass = `${this.prefixClass}__${classToAppend}`;
      return this.direction ? `${resultClass}-${this.direction}` : resultClass;
    },
  },
});
